<div class="card block isMinimizable"
     [stepContent]="financementStepContent"
     joyrideStep="financementStep">
    <div class="card-header">
        <div class="card-title">
            <h6>Mensualités
                <p class="value">{{ favorite.monthly }} €</p>
            </h6>
            <i class="fa fa-angle-up"></i>
            <h2>Financement</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_financement.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">

            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-12">
                        <mat-slide-toggle class="mb-3" color="primary" [(ngModel)]="cash"
                                          (change)="toogleCash()">Achat sans crédit immobilier
                        </mat-slide-toggle>
                    </div>
                </div>
                <div class="row" *ngIf="cash == false">
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Apport<i class="fa fa-info-circle"
                                                matTooltip="Montant de votre apport dans ce projet. Si l’apport est à 0, cela signifie que vous faites votre crédit sur la totalité du projet : Achat, travaux, mobilier, notaire, frais bancaires ..."></i>
                            </mat-label>
                            <input type="number" step="1000" matInput [(ngModel)]="favorite.apport" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Durée du crédit<i class="fa fa-info-circle" matTooltip="Durée totale du crédit, même si vous bénéficiez d’un différé de crédit. Ce différé sera pris en compte dans l’onglet “imposition”.
Exemple : Pour un crédit de 18 ans + 2 ans de différé, renseignez 20 ans"></i></mat-label>
                            <input type="number" step="1" matInput [(ngModel)]="favorite.duration" (ngModelChange)="edit($event)">
                            <span matSuffix>ans</span>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Taux du crédit</mat-label>
                            <input type="number" step="0.1" matInput [(ngModel)]="favorite.rate" (ngModelChange)="edit($event)">
                            <span matSuffix>%</span>
                        </mat-form-field>
                    </div>

                    <div class="col-6"
                         *ngIf="authenticationService.isLogin && authenticationService.currentUser.pro_plan == 'oikos'">
                        <mat-form-field>
                            <mat-label>Taux du crédit sur 25 ans</mat-label>
                            <input type="number" step="0.1" matInput [(ngModel)]="favorite.rate_second" (ngModelChange)="edit($event)">
                            <span matSuffix>%</span>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Taux assurance<i class="fa fa-info-circle"
                                                        matTooltip="Taux de l’assurance emprunteur."></i></mat-label>
                            <input type="number" step="0.1" matInput [(ngModel)]="favorite.rate_insurance" (ngModelChange)="edit($event)">
                            <span matSuffix>%</span>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Frais bancaire<i class="fa fa-info-circle"
                                                        matTooltip="Montant des frais bancaires (aussi appelés frais de dossier) et des frais de courtage si nécessaire."></i>
                            </mat-label>
                            <input type="number" step="100" matInput [(ngModel)]="favorite.banking_fees" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Frais de cautionnement<i class="fa fa-info-circle"
                                                                matTooltip="Montant des frais demandés par votre organisme de cautionnement (Crédit logement, SACCEF, CMH ...) ou les frais d’hypothèque."></i>
                            </mat-label>
                            <input type="number" step="100" matInput [(ngModel)]="favorite.deposit_fees" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-md-4" *ngIf="cash == false">
                <div class="h-100 pb-3">
                    <div class="data_moy h-100">
                        <div class="indicateur text-center mt-2 mt-md-5 kpi-cout">
                            <label>Emprunt total<i class="fa fa-info-circle ms-2"
                                                   matTooltip="Il correspond au montant de votre crédit immobilier. Il est obtenu à partir du coût total du projet (Achat, travaux, mobilier, notaire, frais bancaires ...) auquel est retiré votre apport."></i></label>
                            <b class="value">{{ favorite.total_price - favorite.apport | number:'1.0-0' }} <span
                                class="unit">€</span></b>
                        </div>

                        <div class="indicateur text-center mt-2 kpi-taux">
                            <label>Taux de couverture<i class="fa fa-info-circle ms-2"
                                                        matTooltip="Il s’agit de la mensualité de crédit divisé par le loyer total. Pour un investissement qui s’autofinance, il est conseillé d’avoir un taux de couverture inférieur à 70%. Cela permettra d’utiliser les 30% du loyer restant pour payer les différentes charges"></i></label>
                            <b [ngClass]="{'value' :true, 'text-green' : favorite.coverage_rate <= 70, 'text-red' : favorite.coverage_rate > 70}">{{ favorite.coverage_rate | number:'1.0-0' }}
                                <span class="unit">%</span></b>
                            <mat-hint class="d-sm-none">Mensualité / loyer</mat-hint>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #financementStepContent>
    <div class="user_onboarding_content">
        <h2>Votre financement</h2>
        <p>
            Renseignez les caractéristiques de votre <b>prêt immobilier</b> pour calculer votre mensualité.<br/>
            <br/>
            <b>Astuce</b> : Pour ne pas utiliser de crédit dans la simulation, vous pouvez mettre en apport le coût
            total du projet.<br/>
        </p>
    </div>
</ng-template>
